import { createRouter, createWebHistory } from "vue-router";
import { constRouter } from "./router";
// import { useStore } from "@/store";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: constRouter,
});

// router.beforeEach((to, from, next) => {
//   // if (to.name !== "login" && !store.loginAuthentication)
//   //   next({ name: "login" });
//   const store = useStore();
//   store.establishConnection();
//   next();
// });

// router.afterEach(() => {
//   const store = useStore();
//   store.finishConnection();
// });

router.onError((error) => {
  console.error(error);
  window.$notification.error({
    content: "页面加载错误",
    meta: `页面加载错误：${error}`,
    keepAliveOnHover: true,
    duration: 5,
  });
});

export default router;
